import { useState } from 'react'
import './track.scss'
import { useNavigate } from 'react-router-dom'
import LoaderBtn from '../LoaderBtn/LoaderBtn'
import { useNotification } from '../../context/NotificationContext'
import { getOrder } from '../../api/requests'
import 'animate.css'

const Track = () => {
    const { notify } = useNotification()
    const navigate = useNavigate()

    const [trackData, setTrackData] = useState({
        orderId: '',
        orderData: [],
        isLoading: false
    })

    const setInput = (input: string) => {
        setTrackData((prev) => {
            return {
                ...prev,
                orderId: input
            }
        })
    }


    const setLoader = (value: boolean) => {
        setTrackData((prev) => {
            return {
                ...prev,
                isLoading: value
            }
        })
    }


    const handleTrack = async () => {

        if (trackData.orderId === '') {
            notify.error('Please input Order Id')
            return
        }



        try {
            setLoader(true)

            let res = await getOrder(trackData.orderId)

            if (res) {
                navigate(`/tracking/${trackData.orderId}`)
            }



        } catch (error: any) {
            notify.error(error.message)
        } finally {
            setLoader(false)
        }

    }


    return (<div className='trackorders animate__animated animate__fadeIn animate__fast'>

        <div className='centerbox'>

            <div className="titleside">
                <div className='ptitle'>Track Your Package</div>
                <div className='pinfo'>Real time updates, every step of the way</div>
            </div>


            <div className='inputside'>
                <div className='label'>Order ID</div>
                <div className='trackBox'>

                    <input placeholder='Your Order number' value={trackData.orderId} onChange={(e) => setInput(e.target.value)}></input>
                    <LoaderBtn className={'btn'} text={'Track Order'} clickFunction={handleTrack} isLoading={trackData.isLoading}></LoaderBtn>
                </div>
            </div>


        </div>



    </div>)
}


export default Track